/* tslint:disable */
/* eslint-disable */
/**
 * Registration App Tier Micro Service APIs
 * Registration App Tier Micro Service APIs
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RegistrationStatus = {
    Started: 'STARTED',
    SubmitStarted: 'SUBMIT_STARTED',
    MdmsAccountRegistered: 'MDMS_ACCOUNT_REGISTERED',
    Completed: 'COMPLETED',
    CompletedByAutoRenew: 'COMPLETED_BY_AUTO_RENEW',
    CoapplicantInvited: 'COAPPLICANT_INVITED',
    ReadyToSendInvitation: 'READY_TO_SEND_INVITATION',
    InviteSent: 'INVITE_SENT'
} as const;
export type RegistrationStatus = typeof RegistrationStatus[keyof typeof RegistrationStatus];


export function RegistrationStatusFromJSON(json: any): RegistrationStatus {
    return RegistrationStatusFromJSONTyped(json, false);
}

export function RegistrationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationStatus {
    return json as RegistrationStatus;
}

export function RegistrationStatusToJSON(value?: RegistrationStatus | null): any {
    return value as any;
}

